import { Notification } from './notifications.types';

/**
 * Tells which notifications are new since the bell last looked, so it can ring
 * for them.
 *
 * The first load only takes note of what is there: what was already unread at
 * sign-in or on a reload is shown by the badge and does not ring. After that,
 * an unread notification with an id never seen before is new, once.
 */
export class NewNotificationTracker {
  private _seen: Set<string> | null = null;

  /** Takes in a freshly loaded inbox; returns the ids of the unread ones that are new. */
  observe(notifications: Notification[]): string[] {
    const priming = this._seen === null;
    const seen = (this._seen ??= new Set<string>());
    const fresh = notifications
      .filter((notification) => !notification.read && !seen.has(notification.id))
      .map((notification) => notification.id);
    notifications.forEach((notification) => seen.add(notification.id));
    return priming ? [] : fresh;
  }
}
